import {h, Fragment} from "preact"
import { useEffect, useState } from "preact/hooks";
import {
    toggleButtonId,
    GRID_CLASSES,
    STORAGE_KEY,
    setGridLayout,
    applyGridClass,
} from "./Sidebar";
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick } from "@nosto/preact";
import { sortOptions } from "../config";
import Select from "./elements/Select";

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label 
        For={toggleButtonId} 
        class="btn black uppercase whitespace-nowrap" 
        data-scroll-label="Filter and sort">
            <span>Filter and sort</span>
        </label>
    )
}

export default function Toolbar() {
  const { loading, query, response, pageType } = useAppStateSelector(state =>
    pick(state, "loading", "query", "response", "pageType")
  );

  const { activeSort, setSort } = useSort(sortOptions);
  const selectedFiltersCount = useSelectedFiltersCount();
  const [gridClass, setGridClass] = useState(GRID_CLASSES.LARGE);

  const handleSortChange = event => {
    setSort(event.target.value);
  };

  const docCount = response.products?.total ?? 0;
  const totalSummary =
    pageType === "category"
      ? `${docCount} products`
      : `'${query.query}' - ${docCount} results`;

  const options = sortOptions.map(o => ({
    value: o.id,
    label: o.value.name,
  }));

  // On mount, sync grid layout from localStorage and apply it
  useEffect(() => {
    const savedClass = localStorage.getItem(STORAGE_KEY) || GRID_CLASSES.LARGE; 
    setGridLayout(savedClass);
    setGridClass(savedClass);
  }, []);

  const handleGridChange = (newClass) => {
    setGridLayout(newClass); // applies to DOM + localStorage
    setGridClass(newClass);  // updates local state for UI feedback
  };

  return (
    <div
      class="flex justify-between px-8 py-12 w-full lg:hidden"
      style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
    >
      <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-l-block nos-w-100 w-full placeholder-h-facet-bar-mobile">
        <div class="w-fit">
            <ToggleMobileSidebarButton selectedFiltersCount={selectedFiltersCount} />
        </div>

        <div className="flex gap-12" ref="gridIconWrapperMobile">
            <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            height="12"
            width="10"
            class={`cursor-pointer ${GRID_CLASSES.SMALL}`}
            style={{ fillOpacity: gridClass === GRID_CLASSES.SMALL ? 1 : 0.3 }}
            onClick={() => handleGridChange(GRID_CLASSES.SMALL)}
            >
                <path fill="#000" d="M0 0h10v5H0zM0 7h10v5H0z" />
            </svg>

            <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            height="12"
            width="10"
            class={`cursor-pointer ${GRID_CLASSES.LARGE}`}
            style={{ fillOpacity: gridClass === GRID_CLASSES.LARGE ? 1 : 0.3 }}
            onClick={() => handleGridChange(GRID_CLASSES.LARGE)}
            >
                <path fill="#000" d="M0 0h4v12H0zM6 0h4v12H6z" />
            </svg>
        </div>
      </div>
    </div>
  );
}

